/**
 * me/preferences.tsx — Account preferences surface.
 *
 * Lives at `/me/preferences`. Auth-gated — unauthenticated users get
 * redirected to `/login?redirect=/me/preferences`.
 */

import type { ReactNode } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { PageHeader } from '../../components/ui/PageHeader.js';
import { PreferencesForm } from '../../components/student/PreferencesForm.js';
import { freshSessionQuery } from '../../lib/api/queries.js';
import type { SessionPrincipal } from '../../lib/api/queries.js';

export const Route = createFileRoute('/me/preferences')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.fetchQuery(freshSessionQuery);
    const user = session?.ok ? (session.data?.user ?? null) : null;
    if (!user) {
      throw redirect({
        to: '/login',
        search: { error: undefined, redirect: location.href },
      });
    }
    return null;
  },
  component: PreferencesPage,
});

function PreferencesPage(): ReactNode {
  return (
    <main className="page-shell">
      <PageHeader
        eyebrow="Akun"
        title="Preferensi kamu"
        description="Atur mode fokus, animasi, dan suara. Preferensi ini berlaku di semua perangkat yang kamu masuki."
      />
      <section className="section surface">
        <PreferencesForm />
      </section>
    </main>
  );
}
